export default {
  slug: 'ws-google-map-embed',
  PANEL_HEIGHT: 48,
  MODAL_WIDTH: 570,
  MODAL_HEIGHT: 512,
  BASE_MAP_HREF: 'https://www.google.com/maps/embed/v1/place',
  MODAL_TYPE: '@WS_GOOGLE_MAP_EMBED/PREVIEW_DIALOG',
  DEFAULT_QUERY_SELECTOR: 'ws-iframe[src^="https://www.google.com/maps/embed"]',
  DEFAULT_SOURCE:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3152.780758618558!2d-122.40497274915748!3d37.79517747965643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808ac13be543%3A0x65487a1b70f0a878!2s!5e0!3m2!1sen!2sus!4v1541623525474',
  DEFAULT_ADDRESS: 'Transamerica Pyramid, 600 Montgomery St, San Francisco, CA 94111, USA',
  TAG_NAME: 'ws-iframe',
};
